import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyC0z_oxDW0e2O-4vIrzE39NCCG9owxAl0w",
    authDomain: "ratemyvandycourse.firebaseapp.com",
    projectId: "ratemyvandycourse",
    storageBucket: "ratemyvandycourse.appspot.com",
    messagingSenderId: "1072387069500",
    appId: "1:1072387069500:web:d98cb74dbc5fa67376d539",
    measurementId: "G-374FPYNPNF"
  };
  
  const app = initializeApp(firebaseConfig);
  export const db = getFirestore(app);
  